




























































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

@Component
export default class ActivityNameModal extends Vue {
  @Prop({ required: true, default: false }) show!: boolean;

  @Getter("documentTitle") documentTitle!: string;
  @Getter("originalTitle") originalTitle!: string;
  @Getter("titleSection") titleSection!: any;
  @Getter("mainTextColor") mainTextColor!: any;


  @Action("changeDocumentTitle")
  changeDocumentTitle!: Function;

  type: string = "origin";
  currentTitle: string = "";

  mounted() {
    setTimeout(() => {
      if (this.documentTitle === this.originalTitle) {
        this.type = "origin";
      } else {
        this.type = "custom";
        this.currentTitle = this.documentTitle;
      }
    }, 1000)
  }

  handleChangeType(type: string): void {
    this.type = type;
  }

  handleCancle() {
    this.$emit("hide");
  }

  handleOk() {
    if (this.type === "origin") {
      this.changeDocumentTitle(this.originalTitle);
    } else {
      this.changeDocumentTitle(this.currentTitle);
    }
    parent.postMessage({
      value: this.currentTitle,
      action: 'changeTitle',
    },'*');
    this.$emit("hide");
  }
}
